import { render, staticRenderFns } from "./taocxf.vue?vue&type=template&id=aa0f786a&scoped=true&"
import script from "./taocxf.vue?vue&type=script&lang=js&"
export * from "./taocxf.vue?vue&type=script&lang=js&"
import style0 from "./taocxf.vue?vue&type=style&index=0&id=aa0f786a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0f786a",
  null
  
)

export default component.exports